<template>

    <div class="main-body position-relative">
    
      <div class="nav-title position-absolute flex flex-center-cz">
          <div class="flex flex-center-cz margin-left-xl font-xl font-bold flex-space-between">
            <span class="pointer" >回收站</span>
          </div>
          <div class="blue-btn flex flex-center-cz flex-center-sp pointer margin-right-xl" @click="clearAll">清空回收站</div>
      </div>
      <div class="file-pnl" style="margin-top:45px">
          <div v-for="item in fileData" style="width: 25%;" class="flex flex-center-sp">
              <div class="file-box boder-box">
                <div class="pointer dir-box" @click="gridItemClick(item.id)"  >
                  <img v-if="item.cover != null && item.cover != ''" class="file-img" :src="item.cover" />
                  <div v-if="item.cover == null || item.cover == ''" class="file-img padding-s font-s border-box">{{item.summary}}</div>
                </div>
                <div class="file-desc">
                  <div class="file-left">
                    <div class="file-name text-more row1 full-width">{{item.name}}</div>
                    <div class="flex flex-row file-remark">
                      <div class="margin-right-l flex flex-row" style="width:40px"><img class="dianzan-ico" src="@/assets/images/dianzan.png"/><div class="margin-left-m ">{{item.likeCount}}</div></div>
                      <div class="margin-right-l flex flex-row" style="width:45px"><img class="chakan-ico" src="@/assets/images/chakan.png"/><div class="margin-left-m ">{{item.viewCount}}</div></div>
                      <div class="margin-right-l flex flex-row" style="width:45px"><img class="pinglun-ico" src="@/assets/images/pinglun.png"/><div class="margin-left-m ">{{item.commentCount}}</div></div>
                      <div class="margin-right-l flex flex-row" style="width:45px"><img class="shoucang-ico" src="@/assets/images/shoucang.png"/><div class="margin-left-m ">{{item.collectCount}}</div></div>
                    </div>
                  </div>
                  <div class="file-right">
                    <div class="file-more pointer"  @click="showMore(item, $event)"><img class="more-img" src="@/assets/images/icmore.png" /></div>
                  </div>
                </div>                
              </div>
          </div>
      </div> 

      <div v-if="fileData != null && fileData.length == 0" style="margin-top: 50px;width: 95%;" class="flex flex-col flex-center-cz">
          <img style="width: 250px;height: 250px;" src="@/assets/images/empty-data.png"/>
          <div class="font-l">空空如也</div>
      </div>
        
      <popup-menu ref="child" :menuData="menuData"  @menuClick="menuClick" >
      </popup-menu>

    </div>     
    
    </template>
    
    <script>
      /*
            名称：回收站
            功能：
            作者：唐赢   
            时间：2023-1-24
      */
    
      import {recoveryList, recovery,remove, removeAll} from '@/api/api.js';
      import PopupMenu from '@/components/popupMenu/PopupMenu' 
      import Mixin from '@/mixin/mixin';

      export default {
        name: 'Main',
        components: {
          PopupMenu
        },
        mixins:[Mixin],
        data () {
          return {
            fileData: null,
            menuData:[{id:'restore',name:'恢复'},{id:'delete',name:'彻底删除'}],   //菜单数据                
          }
        },
        created() {
          this.list();
        },
        methods: {

          menuClick(id) {
                console.log("menu.....",id);
                if (id == 'restore') {
                  this.$showMsgBox({
                        caption:"询问",
                        msg: '确定要恢复？',
                        callback:(data) => {
                            if (data == "yes") {
                              recovery(this.selectId).then((res) => {
                                    if (res.data.success == true) {
                                        this.$emit("change")
                                        this.list();
                                        return;
                                    } else {
                                        this.$showToast({msg: res.data.message});
                                        return;                       
                                    }
                                })
                            } 
                        }
                    })
                }
                else if (id == 'delete') {
                    this.$showMsgBox({
                        caption:"询问",
                        msg: '确定要彻底删除吗？',
                        callback:(data) => {
                            if (data == "yes") {
                              remove(this.selectId).then((res) => {
                                    if (res.data.success == true) {
                                        this.$emit("change")
                                        this.list();
                                        return;
                                    } else {
                                        this.$showToast({msg: res.data.message});
                                        return;                       
                                    }
                                })
                            } 
                        }
                    })
                }
            },

            list() {
              this.$showLoading();
              recoveryList().then((res) => {
                console.log(res);
                this.$closeLoading();
                this.fileData = res.data.result;
              })
            },
            gridItemClick(id) {
                this.$router.push({
                  path: '/doc',
                  query: {
                    id: id 
                  }
              })
            },  

            showMore(item, event) {
              this.selectId = item.id;
              this.$refs.child.show(event);//调用子组件的show方法，用于显示弹出式菜单，引用组件时，需要 ref="child"

            },
            stopPropa(event) {
                event || (event = window.event);
                event.stopPropagation ? event.stopPropagation(): (event.cancelBubble = true);
                document.addEventListener("click", this.closeClick, false);// 监听关闭事件
            },
    
            closeClick(e) {
                console.log("销毁监听事件。");
                document.removeEventListener("click", this.closeClick, false);
                this.showOpMenu = false;
            },
            clearAll(e){
              this.$showMsgBox({
                    caption:"询问",
                    msg: '确定要清空回收站吗？',
                    callback:(data) => {
                        if (data == "yes") {
                          removeAll().then((res) => {
                                if (res.data.success == true) {
                                    this.$emit("change")
                                    this.list();
                                    return;
                                } else {
                                    this.$showToast({msg: res.data.message});
                                    return;                       
                                }
                            })
                        } 
                    }
                })

            }

          
        }
      }
    </script>
    
      <!-- Add "scoped" attribute to limit CSS to this component only -->
    <style scoped>

        .file-right{
            width: 35px;
        }
        .dir-box {
            overflow: hidden;
            height: 170px;
        }
    </style>
      


// WEBPACK FOOTER //
// src/views/Recovery.vue